'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useMemo} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import cn from 'classnames';
import styles from './scroll_index.module.less';

interface I_header_item {
    id: string;
    text: string;
    level: number;
}

interface I_scroll_index_props {
    headers: I_header_item[];
    active_header_id: string | null;
    on_header_click: (header_id: string) => void;
}

export const Scroll_index = (props: I_scroll_index_props)=>{
    const {theme} = useContext(Settings_context);
    const active_index = useMemo(()=>{
        return props.headers.findIndex(header=>
            header.id == props.active_header_id);
    }, [props.headers, props.active_header_id]);
    const indicator_style = useMemo(()=>{
        if (active_index == -1)
            return {};
        const all_headers = document.querySelectorAll('#right_menu > li');
        const margin = 16;
        let header_top = 0;
        for (let i = 0; i < active_index; i++)
            header_top += all_headers[i].clientHeight + margin;
        const active_header_height = all_headers[active_index].clientHeight;
        return {
            top: `${header_top}px`,
            height: `${active_header_height}px`
        };
    }, [active_index, props.headers.length]);
    return <div className={styles.scroll_index_container}>
      <p className={cn(theme.p12, theme.med, styles.title)}>
        IN THIS ARTICLE:</p>
      <div className={styles.content_wrapper}>
        <div className={styles.vertical_line}>
          <div className={cn(styles.active_indicator)}
            style={indicator_style}/>
        </div>
        <ul id='right_menu' className={styles.header_list}>
        {props.headers.map(header=>
          <li
            key={header.id}
            className={cn(
              styles.header_item,
              theme.P,
              theme.p14,
              header.id == props.active_header_id ? theme.med : theme.reg,
              header.id == props.active_header_id && styles.active
            )}
            onClick={()=>props.on_header_click(header.id)}
            >
            {header.text}
          </li>
        )}
        </ul>
      </div>
    </div>;
};
